import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import {
  CommonUtility, WpPerson, EmploymentPlan, EmploymentPlanSummary,
  RequestVO, Task, WpReferral, EmploymentPlanCorVo, ComponentSummary
} from '../shared';
import { DateUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-employment-plan',
  templateUrl: './employment-plan.component.html',
  styleUrls: ['./employment-plan.component.scss']
})
export class EmploymentPlanComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('fileInput2') fileInput2: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('prevTextSave') prevTextSave: ElementRef;
  @ViewChild('prevTextReset') prevTextReset: ElementRef;

  tabIndex: any = '-1';
  startDateTabIndex: any = '-1';

  employmentPlan: EmploymentPlan;
  employmentPlanPrev: EmploymentPlan;

  sharedData: any;
  notesSize = 0;
  serverConstants: any;
  userActionNotificationsMap: any;
  componentSummary: ComponentSummary;
  empPlanStatusMap: any;
  shortTermGoalMap: any;
  longTermGoalMap: any;
  shortTermGoalArray: any[];
  longTermGoalArray: any[];
  empPlanStatusArray: any[];


  editable: Boolean = false;
  nonEditable: Boolean = false;

  minESDate: NgbDateStruct;
  maxESDate: NgbDateStruct;
  minECDate: NgbDateStruct;
  minCADate: NgbDateStruct;
  maxCADate: NgbDateStruct;


  today: Date = new Date();
  startdateArray: Date;



  isView: Boolean = true;

  isCaseCloseVisible = false;
  estimatedCompletionDt?: any;
  disableEstimatedCompletionDt = false;
  programCd;
  etEnrollment;
  closureReeasonArray;
  clientSigningStatusArray;
  employmentSummary;
  assessmentStartDate;

  disableEditStatusArray = ['CC'];
  isChangeDetected = false;
  closureReeasonCd: any;
  isCurrentEnrollment:Boolean = false;
  isPrintEnabled = false;
  isSigningStatusPending = false;
  userRole: Array<any> = [];
  isFocused = false;
  disableSave: boolean = false;
  employmentPlanCorVo: EmploymentPlanCorVo;
  countiesMap;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('EMPPL') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {




    this.dataService.globalAccess = true;

    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    this.empPlanStatusArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_PLAN_STATUS');
    this.empPlanStatusMap = this.commonUtil.createMapFromList(this.empPlanStatusArray);

    this.closureReeasonArray = this.data.getValueFromSharedDataMap('CASE_CLOSURE_REASON');
    this.clientSigningStatusArray = this.data.getValueFromSharedDataMap('Client_Signing_Status');

    this.shortTermGoalArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_SHORT_TERM_GOAL');
    this.shortTermGoalMap = this.commonUtil.createMapFromList(this.shortTermGoalArray);
    this.longTermGoalArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_LONG_TERM_GOAL');
    this.longTermGoalMap = this.commonUtil.createMapFromList(this.longTermGoalArray);

    const countiesArray = this.data.getValueFromSharedDataMap('COUNTIES');
    this.countiesMap = this.commonUtil.createMapFromList(countiesArray);


    this.sharedData = this.dataService.getSharedDataObject();
    this.employmentPlan = Object.assign({}, this.sharedData.get('employmentPlan'));
    this.sharedData.get('roles').forEach(role => {
      this.userRole.push(role.id);
    });
    console.log(this.userRole);

    this.employmentSummary = this.sharedData.get('EmploymentSummary');


    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.programCd = this.sharedData.get('etEnrollment').programCd;
    }

    console.log('selectedEnrollmentEndDt= ' + this.sharedData.get('selectedEnrollmentEndDt'));

    if (this.sharedData.get('selectedEnrollmentEndDt') !== null && this.sharedData.get('selectedEnrollmentEndDt') !== undefined
    && this.sharedData.get('selectedEnrollmentEndDt') !== "Current") {
     this.isCurrentEnrollment = false;
    } else {
      this.isCurrentEnrollment = true
    }

    console.log('disableSave: ' + this.disableSave);
    console.log('! isCurrentEnrollment: ' + !this.isCurrentEnrollment);

    this.loadData();

  }

  focus() {
    this.isFocused = true;
  }

  loadData() {
    // edit
    if (this.employmentPlan.id !== undefined) {

      if (this.employmentPlan.notes !== null && this.employmentPlan.notes !== undefined) {
        this.notesSize = this.employmentPlan.notes.length;
      } else {
        this.notesSize = 0;
      }

      if (this.employmentPlan.clientSigningStatus !== 'CP') {
        this.isSigningStatusPending = false;
      } else {
        this.isSigningStatusPending = true;
      }

      if (this.employmentPlan.empPlanStatusCd === 'CL') {
        this.isCaseCloseVisible = true;
        this.isPrintEnabled = true;
      } else {
        this.isCaseCloseVisible = false;
        this.isPrintEnabled = true;
      }

      // this.disableEditStatusArray.includes(this.employmentPlan.empPlanStatusCd)
      if (this.employmentPlan.empPlanStatusCd === 'CL'
        && (!this.disableEditStatusArray.includes(this.employmentPlan.caseClosureReasonCd))) {
        this.editable = true;
        this.startDateTabIndex = '0';
        // this.isView = false;
        if (this.userRole.includes(4)) {
          this.nonEditable = false;
          this.isView = true;
        } else {
          this.nonEditable = true;
          this.tabIndex = '0';
          this.isView = false;
        }
      } else {
        this.editable = true;
        this.startDateTabIndex = '0';
        this.nonEditable = false;
      }

      // The Estimated Completion Date cannot be shortened to a date prior to the date the record is being edited

      const calculatedValue = this.dateUtility.compareDate(this.employmentPlan.empPlanStartDt, this.dateUtility.getTodaysDateWithoutTime());
      if (calculatedValue === 0) {
        this.minECDate = {
          month: this.today.getMonth() + 1,
          day: this.today.getDate() + 1,
          year: this.today.getFullYear()
        };

      } else if (calculatedValue === 1) {
        const startDate = new Date(this.employmentPlan.empPlanStartDt);
        this.minECDate = {
          month: startDate.getMonth() + 1,
          day: startDate.getDate() + 1,
          year: startDate.getFullYear()
        };
      } else {
        this.minECDate = {
          month: this.today.getMonth() + 1,
          day: this.today.getDate(),
          year: this.today.getFullYear()
        };

      }

      this.employmentPlan.empPlanStartDt = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStartDt);
      this.employmentPlan.estimatedCompletionDt = this.dateUtility.convertDateFromServer(this.employmentPlan.estimatedCompletionDt);
      this.employmentPlan.clientAgreementDt = this.dateUtility.convertDateFromServer(this.employmentPlan.clientAgreementDt);
      this.employmentPlan.empPlanStatusDt = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStatusDt);
      this.estimatedCompletionDt = this.employmentPlan.estimatedCompletionDt;
      this.employmentPlanPrev = Object.assign({}, this.employmentPlan);
    } else {
      this.employmentPlan = new EmploymentPlan();
      this.employmentPlanPrev = new EmploymentPlan();
      this.employmentPlan.empPlanStatusDt = this.getSystemDateFromModel();
      if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
        this.etEnrollment = this.sharedData.get('etEnrollment');
      }
      this.employmentPlan.etEnrollmentId = this.etEnrollment.id;

      this.employmentPlan.empPlanStatusCd = 'OP';
      this.startDateValidation();
    }
  }

  dataChanges(status) {


    if (status === 'CL') {
      this.isCaseCloseVisible = true;
      this.employmentPlan.estimatedCompletionDt = this.getSystemDateFromModel();
      this.disableEstimatedCompletionDt = true;
    } else {
      this.isCaseCloseVisible = false;
      this.employmentPlan.estimatedCompletionDt = this.estimatedCompletionDt;
      this.disableEstimatedCompletionDt = false;
    }

    if (this.employmentPlan.empPlanStatusCd !== status) {
      this.employmentPlan.empPlanStatusDt = this.getSystemDateFromModel();
    }

  }
  startDateValidation() {
    const employmentPlanStartDate = this.sharedData.get('employmentPlanEndDate');
    const assessmentStartDate = this.sharedData.get('assessmentStartDate') !== undefined ? this.sharedData.get('assessmentStartDate').slice(0, 10) : undefined;
    const assessmentFormattedStartDate = this.dateUtility.convertDateFromServer(assessmentStartDate);
    const employmentPlanFormattedStartDate = this.dateUtility.convertDateFromServer(employmentPlanStartDate);
    if (employmentPlanStartDate !== undefined && assessmentStartDate !== undefined) {
      const calculatedValue = this.dateUtility.compareDate(employmentPlanStartDate, assessmentStartDate);
      if (calculatedValue === 1) {
        this.minESDate = {
          month: employmentPlanFormattedStartDate['month'],
          day: employmentPlanFormattedStartDate['day'],
          year: employmentPlanFormattedStartDate['year']
        };
      } else if (calculatedValue === -1) {
        this.minESDate = {
          month: assessmentFormattedStartDate['month'],
          day: assessmentFormattedStartDate['day'],
          year: assessmentFormattedStartDate['year']
        };
      } else {
        this.minESDate = {
          month: employmentPlanFormattedStartDate['month'],
          day: employmentPlanFormattedStartDate['day'],
          year: employmentPlanFormattedStartDate['year']
        };
      }
    } else {
      this.minESDate = {
        month: assessmentFormattedStartDate['month'],
        day: assessmentFormattedStartDate['day'],
        year: assessmentFormattedStartDate['year']
      };
    }
    this.minECDate = {
      month: this.minESDate['month'],
      day: this.minESDate['day'] + 1,
      year: this.minESDate['year']
    };
    this.maxCADate = {
      month: this.minESDate['month'],
      day: this.minESDate['day'],
      year: this.minESDate['year']
    };
  }
  validAptDate() {

    if (this.employmentPlan.id === undefined && this.employmentPlan.empPlanStartDt !== undefined) {
      const startPlusOne = this.dateUtility.addDays(this.dateUtility.convertDateForServer(this.employmentPlan.empPlanStartDt), 1);
      this.minECDate = {
        month: startPlusOne.getMonth() + 1,
        day: startPlusOne.getDate(),
        year: startPlusOne.getFullYear()
      };
      this.maxCADate = {
        month: this.employmentPlan.empPlanStartDt['month'],
        day: this.employmentPlan.empPlanStartDt['day'],
        year: this.employmentPlan.empPlanStartDt['year']
      };
      this.minCADate = this.employmentPlan.empPlanStartDt;
      // this.maxCADate = this.minCADate;
    }
  }

  printCorrespondence() {
    this.dataService.addValueToSharedDataMap('appointmentCorrespondence', this.employmentPlan);
    this.router.navigate(['task/correspondence']);
  }

  changeDetected() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }

  focusFirstEnabledField() {
    if (this.editable === false) {
      setTimeout(() => this.fileInput.nativeElement.focus(), 0);
    } else {
      setTimeout(() => this.fileInput2.nativeElement.focus(), 0);
    }
  }

  save() {
    this.isChangeDetected = false;
    this.modalPopupService.setChangeDetected(false);
    const activeStatusArray = [];
    if (this.employmentSummary !== undefined && this.employmentSummary.length > 0) {
      this.employmentSummary.forEach(element => {
        if (element.id !== this.employmentPlan.id) {
          activeStatusArray.push(element.empPlanStatusCd);
        }
      });
    }

    if (!(this.employmentPlan.empPlanStatusCd === 'OP' && activeStatusArray.includes('OP'))) {
      this.employmentPlan.deleteSw = 'N';


      const copyEmpPlan = Object.assign({}, this.employmentPlan);
      copyEmpPlan.empPlanStartDt = this.dateUtility.convertDateForServer(this.employmentPlan.empPlanStartDt);
      copyEmpPlan.estimatedCompletionDt = this.dateUtility.convertDateForServer(this.employmentPlan.estimatedCompletionDt);
      copyEmpPlan.clientAgreementDt = this.dateUtility.convertDateForServer(this.employmentPlan.clientAgreementDt);
      copyEmpPlan.empPlanStatusDt = this.dateUtility.convertDateForServer(this.employmentPlan.empPlanStatusDt);


      const referralId = this.sharedData.get('referralId');

      const providerId = this.sharedData.get('providerId');
      let personId = 0;
      if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
        personId = Number(this.sharedData.get('wpPersonId'));
      }

      let indicator = 'C';
      let assignedTo = 0;
      if (providerId > 0) {
        assignedTo = providerId;
        indicator = 'P';
      } else {
        const personProvider = this.sharedData.get('personProvider');
        if (personProvider !== undefined && personProvider != null && personProvider.id !== undefined) {

          assignedTo = personProvider.id.serviceCounty;

        }
      }



      const wpPerson = new WpPerson();
      wpPerson.id = personId;
      const wpReferral = new WpReferral();
      wpReferral.id = Number(referralId);

      const oldTask = new Task();

      oldTask.assignedTo = String(assignedTo);
      oldTask.assignedToInd = indicator;
      oldTask.taskType = 'EP';
      oldTask.wpReferral = wpReferral;
      oldTask.wpPerson = wpPerson;

      const newTask = Object.assign({}, oldTask);
      newTask.taskType = 'CM';
      newTask.programCd = this.programCd;

      const assessmentRequestVO = new RequestVO(copyEmpPlan, newTask, oldTask);
      console.log('assessmentRequestVO.mainObject.id : ' + assessmentRequestVO.mainObject.id);
      if(assessmentRequestVO.mainObject.empPlanStatusCd === 'CL') {       
        this.http.get<ComponentSummary>(this.serverConstants.SERVER_API_URL + '/component/load/activeComponents/'+ assessmentRequestVO.mainObject.id).subscribe(
          (data: ComponentSummary) => {
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
            } else {
              if (data != null) {
                if (data.component.length > 0) {
                  this.notificationService.error('Employment Plan Details', 'Please close all associated components prior to closing the employment plan.');
                } else {
                  this.saveEmpPlan(assessmentRequestVO);                                
                }
              }
            }
    
          }, response => {
           
          }, () => {
          }); 
      } else {
        this.saveEmpPlan(assessmentRequestVO);         
      }              

    } else {
      this.notificationService.warn('Employment Plan Details', 'Already active employment plan exist');
    }
  }

  resetAgreementDeclinedDate() {
    if(this.employmentPlan.clientSigningStatus === 'CP') {
      this.employmentPlan.clientAgreementDt = '';
    }
    
  }

  private saveEmpPlan(assessmentRequestVO: RequestVO) {

    console.log('Saving EmpPlan');
    console.log('EmpPlanID -' + this.employmentPlan.id);
    console.log('EmpPlanID MainObject.id -' + assessmentRequestVO.mainObject.id);

    this.http.post<EmploymentPlan>(this.serverConstants.SERVER_API_URL + '/employmentplan/save', assessmentRequestVO)
      .subscribe(
        (res: EmploymentPlan) => {
          if (res.hasOwnProperty('errorCode')) {

            if(this.employmentPlan.clientSigningStatus === 'CD' || (this.employmentPlan.empPlanStatusCd === 'CL' && this.employmentPlan.caseClosureReasonCd === 'SC')) {
              this.notificationService.error('Employment Plan Details','Unable to send notification to the eligibility system; system will retry later.');   
              //this.disableSave = true;
            } else {
              this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
            }
        
          } else {
            this.employmentPlan = res;
            this.employmentPlan.empPlanStartDt = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStartDt);
            this.employmentPlan.estimatedCompletionDt = this.dateUtility.convertDateFromServer(this.employmentPlan.estimatedCompletionDt);
            this.employmentPlan.clientAgreementDt = this.dateUtility.convertDateFromServer(this.employmentPlan.clientAgreementDt);
            this.employmentPlan.empPlanStatusDt = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStatusDt);
            if (this.employmentPlan.empPlanStatusCd === 'CL') {
              this.isPrintEnabled = true;
            } else {
              this.isPrintEnabled = true;
            }


            this.notificationService.success('Employment Plan Details', this.userActionNotificationsMap.UPDATE);
            this.notificationService.warn('Employment Status', 'Please review and update the Employment Status on the Enrollment Summary screen.');

            setTimeout(() => this.headerText.nativeElement.focus(), 0);
            this.router.navigate(['task/employmentPlanSummary']);
          }
        },
        (response) => {

          if(this.employmentPlan.clientSigningStatus === 'CD' || (this.employmentPlan.empPlanStatusCd === 'CL' && this.employmentPlan.caseClosureReasonCd === 'SC')) {
            this.notificationService.error('Employment Plan Details','Unable to send notification to the eligibility system; system will retry later.');   
            //this.disableSave = true;
          } else {
            this.notificationService.error('Employment Plan Details', this.userActionNotificationsMap.ERROR);
          }
        },
        () => {
        });
  }

  focusHeaderOnSave(event) {
      if (!event.shiftKey && event.keyCode === 9) {
        event.preventDefault();
        setTimeout(() => this.headerText.nativeElement.focus(), 0);
        this.headerText.nativeElement.click();
      }
  }
  focusHeaderOnPrint(event) {

      if (event.keyCode === 9) {
        event.preventDefault();
        setTimeout(() => this.headerText.nativeElement.focus(), 0);
      }
      if (event.shiftKey && event.keyCode === 9) {
        event.preventDefault();
        setTimeout(() => this.prevTextSave.nativeElement.focus(), 0);
      }

  }
  toggleNgbDatePickerKeyboard(event: KeyboardEvent) {
    const KEY_DOWN = 40;
    var datePickerElement = (<HTMLInputElement>event.target);
    if (event.altKey) {
      if (event.keyCode === KEY_DOWN) {
        datePickerElement.click();
      }
    }
  }
  toggleMultiselctDDKeyboard(event: KeyboardEvent){
    const KEY_UP = 38;
    const KEY_DOWN = 40;
    var multiselectDDElement = (<HTMLElement>event.target);
    if(event.altKey){
       if(event.keyCode === KEY_DOWN || event.keyCode === KEY_UP){
        let multisectDDChildNodes = multiselectDDElement.querySelectorAll('.dropdown-list'); 
        let hiddenAttrsFound = false;
      
        if(multisectDDChildNodes){
         for(let i = 0; i<multisectDDChildNodes.length; i++){
           if ((<HTMLElement>multisectDDChildNodes[i]).hasAttribute('hidden')){
              hiddenAttrsFound = true;
              break;
            }
         }

         for(let i = 0; i<multisectDDChildNodes.length; i++){
           if(hiddenAttrsFound){
            multisectDDChildNodes[i].removeAttribute('hidden');
           } else {
            multisectDDChildNodes[i].setAttribute('hidden', '');
           }
         }
        }
      }
    }
  }


  getSystemDateFromModel() {
    const sysDate = new Date();
    return {
      year: sysDate.getFullYear(),
      month: sysDate.getMonth() + 1,
      day: sysDate.getDate()
    };
  }

  public onQuickTextChanged($event) {

    this.notesSize = this.employmentPlan.notes.length;
  }

  reset() {
    this.employmentPlan = Object.assign({}, this.sharedData.get('employmentPlan'));
    this.loadData();
  }


}





// WEBPACK FOOTER //
// ./src/app/employment-plan/employment-plan.component.ts